"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.resetState = void 0;

var _deepMergeWithArrayMerge = _interopRequireDefault(require("./deepMergeWithArrayMerge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state;

var removeEmptyKeys = obj => {
  Object.keys(obj).forEach(key => {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  });
}; // Deepmerge will set keys to undefined if the second argument passed in has undefined keys.
// Thus, persistedProperties and integrations will be filtered for any first-level undefined keys.


var deepmergeAndDeleteEmptyKeys = (target, source) => {
  var mergedObject = (0, _deepMergeWithArrayMerge.default)(target, source);
  removeEmptyKeys(mergedObject.persistedProperties);
  removeEmptyKeys(mergedObject.integrations);
  return mergedObject;
};

var update = options => {
  state = deepmergeAndDeleteEmptyKeys(state, options);
};

var addToCache = options => {
  state.cache.push((0, _deepMergeWithArrayMerge.default)(options, {}));
};

var takeFromCache = () => {
  return state.cache.shift();
};

var get = () => {
  return (0, _deepMergeWithArrayMerge.default)(state, {});
};

var resetState = () => {
  state = {
    initialized: false,
    enabled: true,
    persistedProperties: {},
    cache: [],
    integrations: {},
    context: {},
    appId: null,
    gaClientId: null
  };
};

exports.resetState = resetState;
var _default = {
  resetState,
  update,
  addToCache,
  takeFromCache,
  get
};
exports.default = _default;
//# sourceMappingURL=state.js.map